<template>
  <div class="main">
    <Header
      :show="true"
      title="修改密码"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        text="密码信息非常重要，请谨慎修改。"
      />
      <van-form
        ref="update"
        @submit="handleClickUpdate"
      >
        <!-- <van-field
          v-model="listQuery.username"
          name="用户名"
          label="用户名"
          placeholder="请输入用户名"
          :rules="[{ required: true }]"
        /> -->
        <van-field
          v-model="listQuery.oldPassword"
          type="password"
          name="旧密码"
          label="旧密码"
          placeholder="请输入旧密码"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="listQuery.newPassword"
          type="password"
          name="新密码"
          label="新密码"
          placeholder="请输入新密码"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="listQuery.rePassword"
          type="password"
          name="重复密码"
          label="重复密码"
          placeholder="请再次输入"
          :rules="[{ required: true }]"
        />
        <div style="margin: .6rem 1rem;">
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { logout as userLogout, updatePassword as updateOne } from '@/api/user.js'

  export default {
    name: "ServiceUserPassword",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        loading: false,
        listQuery: {
          username: null,
          oldPassword: null,
          newPassword: null,
          rePassword: null,
        }
      }
    },
    computed: {
      ...mapGetters({
        username: "user/username"
      }),
    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {
      this.listQuery.username = this.username
    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({
          path:'/service/system/staff/create',
          query: {} ,
        })
      },
      handleClickUpdate() {
        // if ((this.listQuery.username === '') || (this.listQuery.username !== this.username)) {
        //   showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '请输入正确的用户名')
        //   return
        // }
        if (this.listQuery.newPassword !== this.listQuery.rePassword) {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '两次输入的密码不一致')
          return
        }
        // this.listQuery.username = this.username
        Dialog.confirm({
          title: '确认更新用户密码？',
          message: '用户名：' + this.listQuery.username
        }).then(() => {
          const data = {
            username: this.listQuery.username,
            newPassword: this.listQuery.newPassword,
            oldPassword: this.listQuery.oldPassword
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新用户密码', data.message)) {
              userLogout().then(response => {
                this.$router.push({
                  path:'/login'
                })
              }).catch(function(error) {
                console.error(error)
              })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新用户', '取消')
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
